import { useLocalStorage } from '@karnov/kui-react'

import { localStorageKeys } from 'consts/localStorageKeys'

export const useOriginalUrl = () => {
  const [originalUrl, setOriginalUrl] = useLocalStorage<string | null>(
    localStorageKeys.originalUrl,
    null,
  )
  return {
    originalUrl,
    setOriginalUrl,
  }
}
